import { render } from "./AppEndOfService.vue?vue&type=template&id=d4329bdc"
import script from "./AppEndOfService.vue?vue&type=script&lang=js"
export * from "./AppEndOfService.vue?vue&type=script&lang=js"
script.render = render

export default script